// extracted by mini-css-extract-plugin
export default {"my10":"Notfound_my10__nkb8J","fsp7":"Notfound_fsp7__abyQS","fsbtn":"Notfound_fsbtn__SYe+D"};